export default __webpack_public_path__ + "static/media/sungrid-solar-bg.eff4aa3a.png";